import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal } from "react-bootstrap";
import {
  X,
  Lightbulb,
  ChevronLeft,
  ChevronRight,
  Info,
  Check,
  Droplet,
  Thermometer,
  Car,
  Wrench,
  ArrowLeft,
  Gauge,
} from "lucide-react";
import {
  goBack,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { APL_LINK } from "../ServiceConnection/serviceconnection";
export default function ViewMaintanceForm() {
  const location = useLocation();
  const { data, ImageLink ,ImageLinkIpass} = location.state || {};
  const MaintainanceData = data;
  //console.log("MaintainanceData", MaintainanceData);
  // genral Info Section
  const genralinfoSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Info size={18} className="iconViewMaintn" /> Genral Info
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Maintenance Information</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reason</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.maintenance_reasion}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Done By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.assign_staff_name}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Issue with the car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.name_and_issue}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Light Check  Section
  const LightCheckSection = () => {
    return (
      <div className="check-section mb-4 ">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Lightbulb size={18} className="iconViewMaintn" /> Light Check
          </h3>
        </div>
        <div className="section-content card light_check_contrr">
          <div className="card-body heigh_Clss">
            <h4 className="border-bottom py-2">Tail Lights</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tail_right}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tail_left}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reverse Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_reverse_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reverse Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_reverse_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_binker_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tail_binker_left}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">Front Lights</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right Low</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_right_low}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left High</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_left_high}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Right High</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_right_high}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Left Low</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.front_light_left_low}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.blinker_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Blinker Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.blinker_left}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Oil Check Section
  const OilCheckSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Droplet size={18} className="iconViewMaintn" /> Oil Check
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Day Since Last Oil Check
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.days_age} Days
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Level</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.oil_level}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Quality</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.oil_quantity}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Added(Quantity in Quats)
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_added_quantity}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Change By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.oil_changed_by}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Pictures of repairs
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={
                      APL_LINK +
                      ImageLink +
                      MaintainanceData.picture_of_closed_oil
                    }
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Tire Inpection Section
  const TireInspectionSection = () => {
    return (
      <div className="notes-section height_tire_isnpection mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Wrench size={18} className="iconViewMaintn" /> Tire Inspection
          </h3>
        </div>
        <div className="section-content card tire_inspection_Contr">
          <div className="card-body">
            <h4 className="border-bottom py-2">Tire Air Pressure(35-40PSI)</h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_front_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_front_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_rear_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_air_rear_right}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">
              Tire Tread Depth | Tire Position
            </h4>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_front_right}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Front Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_front_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Left</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_rear_left}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Rear Right</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.tire_trade_rear_right}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Tire Action</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.tire}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Replaced Tire</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.replace_tire}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Fluid Check  Section
  const FluidCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Thermometer size={18} className="iconViewMaintn" /> Fluids Check
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Break Fluid</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.break_fluid}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Coolant</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.coolant_fluid}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Windshild Washer
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.windshield_washer}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Check Gas Cap</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={APL_LINK + ImageLink + MaintainanceData.check_gas_cap}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Car Inspection   Section
  const CarInspectionSection = () => {
    return (
      <div className="notes-section mb-4 margin_class_inspection">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Car size={18} className="iconViewMaintn" /> Car Inspection
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            {/* <h4 className="border-bottom py-2">Day Since Last Oil Check</h4> */}

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Finder Liners/Engine Liners
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.fender_liners}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">City Sticker</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.city_stiker}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Take Picture of the City Sticker
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={APL_LINK + ImageLink + MaintainanceData.city_sticker}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Heating & Ac Check
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.ac_check}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Reset Maintenance
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.reset_maintainance}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Odometer Reading
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.odo_metter}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                 IPASS Number
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.last_5_digit_ipass}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Take Picture of IPASS
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={APL_LINK + ImageLinkIpass + MaintainanceData.ipass_image}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  //code Reading imgs
  const images = [
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTf6ilC0GKhSiu5ASE6Xnj8DCZESewGQMPyrw&s",
    "https://i.pinimg.com/736x/3d/50/0d/3d500da130a5ac6219b8b1ec175b34c3.jpg",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAa9WPpTr0ZDywZmHZmt8VXE8sNo2UaqGxLw&s",
    "https://thumbs.dreamstime.com/b/obd-scanner-auto-mechanic-hand-engine-system-analysis-car-maintenance-concept-313343437.jpg",
  ];

  const [showModal, setShowModal] = useState(false);
  //damage modal

  const [currentIndex, setCurrentIndex] = useState(0);
  const [ImAgeShowlist, setImAgeShowlist] = useState([]);

  const openModal = (image, index) => {
    setCurrentIndex(index);
    setImAgeShowlist(image);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % ImAgeShowlist.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + ImAgeShowlist.length) % ImAgeShowlist.length
    );
  };
  // Safety Check   Section

  const SafetyCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Gauge size={18} className="iconViewMaintn" /> Dashboard & Safety
            Checks
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Dashboard Warning Lights
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.dashboard_safety}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Picture of Dashboard
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  <img
                    src={
                      APL_LINK + ImageLink + MaintainanceData.dashboard_image
                    }
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                    className="step_8_img_view"
                  ></img>
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Horn Functionality
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.horn_working}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Phone Charging
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.phone_charging}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Wiper Blades</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.wiper_blade}</span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Wiper Working</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.wiper_working}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  // Final Check   Section
  const FinalCheckSection = () => {
    return (
      <div className="notes-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            {" "}
            <Check size={18} className="iconViewMaintn" /> Final Check
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Code Reading Image
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="code_img_cntr">
                  {(() => {
                    const imageArray = [1, 2, 3, 4]
                      .map((i) => MaintainanceData[`coderead_image${i}`])
                      .filter((url) => url);

                    return imageArray.map((imageUrl, i) => (
                      <div className="col-3" key={i}>
                        <img
                          src={APL_LINK + ImageLink + imageUrl}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Image ${i + 1}`}
                          className="Img_contr_code_main"
                          onClick={() => openModal(imageArray, i)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    ));
                  })()}
                </div>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Remarks for Codes on Dashboard
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.remark_dashboard_code}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Damage</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.damage_status == "someDamage"
                    ? "Yes"
                    : "No"}
                </span>
              </div>
              {/*--------if yes --------- */}

              {MaintainanceData.damage_status === "someDamage" && (
                <div className="field-value-container d-flex justify-content-end YesDamage">
                  <div className="code_img_cntr">
                    {(() => {
                      const imageArray = [1, 2, 3, 4]
                        .map((i) => MaintainanceData[`damage_image${i}`])
                        .filter((url) => url);

                      return imageArray.map((imageUrl, i) => (
                        <div className="col-3" key={i}>
                          <img
                            src={APL_LINK + ImageLink + imageUrl}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                            alt={`Image ${i + 1}`}
                            className="Img_contr_code_main"
                            onClick={() => openModal(imageArray, i)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              )}
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Seat Cover Installed
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.seat_cover}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Check if Driver has Oil Bottles
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.driver_oil_bottles}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Snow Brush in Car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{MaintainanceData.snow_brush}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Come to Office to Verify 2nd Key
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.office_verify}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Details of Repair Done
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.details_for_repair}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Pictures of repairs
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="row">
                  {MaintainanceData.pictures_of_repairs
                    ?.split("@@@")
                    .filter((item) => item !== "" && item !== "0")
                    .map((imageName, index) => (
                      <div className="col-3" key={index}>
                        <img
                          src={ImageLink + imageName}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Repair ${index + 1}`}
                          className="img-fluid"
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Notes for Future
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.notes_for_future}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <Header />
      <div className="container-lg">
        {" "}
        <div className="pageCntn_head">
              <div className="pageNameDiv">
                <div className="d-flex gap-2 align-items-center">
                  <p>View Maintenance Details</p>
                  <img
                    src={GreyArrow}
                    alt="Rapid Car Leasing"
                    style={{ height: "14px" }}
                  />
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>
      </div>

      <div className="container-lg ">
        {/* <h2 className="form-title pdding_cclss">Maintenance Details</h2> */}

        <div className="final-checks-container2">
          {/* <div className="form-header mb-4">
            <h2 className="form-title ">Maintenance Details</h2>
          </div> */}
          <div className="row">
            <div className="col-md-6">
              {" "}
              {genralinfoSection()}
              {OilCheckSection()}
              {FluidCheckSection()}
            </div>
            <div className="col-md-6"> {LightCheckSection()}</div>
            <div className="col-md-6"> {TireInspectionSection()}</div>
            <div className="col-md-6">
              {CarInspectionSection()}
              {SafetyCheckSection()}
            </div>
            <div className="col-12">{FinalCheckSection()}</div>
          </div>

          {/* <div className="navigation-buttons">
                            <button className="btn back-button" onClick={onBack}>
                                Back
                            </button>

                            <button className="btn next__button" onClick={handleclickSubmit}>Submit</button>
                        </div> */}
        </div>
      </div>
      <Modal
        className="code_reading_modal"
        show={showModal}
        onHide={closeModal}
        centered
      >
        <Modal.Body className="text-center position-relative">
          <X size={24} className="close_bttn_mdl" onClick={closeModal} />
          <div className="left_right_bttns">
            {" "}
            <button type="button" className="left_img" onClick={prevImage}>
              <ChevronLeft size={30} />
            </button>{" "}
            <button type="button" className="right_img" onClick={nextImage}>
              <ChevronRight size={30} />
            </button>
          </div>

          <img
            src={APL_LINK + ImageLink + ImAgeShowlist[currentIndex]}
            alt="Selected"
            className="img-fluid modal-img coade_iMg"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
